import { render, staticRenderFns } from "./IconSvgCompanyDirectory.vue?vue&type=template&id=6655dbc4&scoped=true&"
import script from "./IconSvgCompanyDirectory.vue?vue&type=script&lang=js&"
export * from "./IconSvgCompanyDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655dbc4",
  null
  
)

export default component.exports